import { ProductConditionSummary, ConditionPrice } from '../../../../types';
import { SortOption, SortOptionEnum } from '../sort-options/types';
import { IProductCondition } from './types';

export const getCondition = (
  condition: ProductConditionSummary,
  currentSort: SortOption
) => {
  return {
    name: condition.name,
    from: getPriceByShipping(condition.priceRange.from, currentSort),
    to: getPriceByShipping(condition.priceRange.to, currentSort),
    count: condition.count,
  };
};

export const getConditions = (
  conditions: ProductConditionSummary[],
  currentSort: SortOption
): IProductCondition[] => {
  const newTypes = getNewType(conditions);
  const usedTypes = getUsedTypes(conditions);
  const conditionList = [];

  if (newTypes) {
    conditionList.push(getCondition(newTypes, currentSort));
  }

  if (usedTypes && usedTypes.count > 0) {
    conditionList.push(getCondition(usedTypes, currentSort));
  }

  return conditionList.length > 1 ? conditionList : [];
};

export function getNewType(types: ProductConditionSummary[]) {
  return types.find(e => e.name === 'new');
}

export function getUsedTypes(types: ProductConditionSummary[]) {
  return types.find(e => e.name === 'used');
}

export function getPriceByShipping(
  price: ConditionPrice,
  currentSort: SortOption
) {
  const includeShipping =
    currentSort === SortOptionEnum.PRICE_INCLUDES_SHIPPING;

  return includeShipping ? price.inclShipping! : price.exclShipping!;
}
